import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LocaleState {
  lang: string
  validLangs: string[]
}

const initialState: LocaleState = {
  lang: 'en',
  validLangs: [],
}

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLocale(state, action: PayloadAction<string>) {
      state.lang = action.payload
    },
    setValidLangs(state, action: PayloadAction<string[]>) {
      state.validLangs = action.payload
    },
  },
})

export const { setLocale, setValidLangs } = localeSlice.actions
export default localeSlice.reducer
